<template>
  <div>
    <h3>Regroupements par secteurs et sous-régions</h3>
    <select v-model="sector">
      <option value="">Tous</option>
      <option value="chc">CSC</option>
      <option value="css">SSC</option>
      <option value="hosp">Hôpitaux</option>
      <option value="ltc">SLD</option>
      <option value="mha">SMD</option>
    </select>
    <SsrRliss v-for='(value, name) in data' :rliss='name' :data='value' :key="name"
      :secteur="sector"/>
  </div>
</template>

<script>
import SsrRliss from '@/components/ssr/SsrRliss.vue'

export default {
  name: 'OnTableSSR',
  components: {
    SsrRliss,
  },
  data() { return {
    sector: ''
  }},
  props: {
    data: Object
  },
  methods: {
    numberOfElements(obj) {
      return Object.keys(obj).length;
    }
  },
  computed: {
    test1() {
      return Object.entries(this.data);
    }
  }

}
</script>
